<!-- 杭州州互联网法院存证查询 -->
<template>
  <div class="region">
    <template v-if="!isShowInfos">

    
    <div class="certificate"  @keydown.enter="search">
      <div class="certificate-item">
        <p class="item-title">{{info.title_1}}</p>
        <div class="item-input">
          <input
            type="text"
            v-model.trim="formInfo.number"
            @blur="verificationNumber"
            :placeholder="info.holder_1"
          />
        </div>
        <div class="item-tips">
          <div v-if="tipsInfo.number.isError">{{tipsInfo.number.msg}}</div>
        </div>
      </div>
      <div class="certificate-item">
        <p class="item-title">{{info.title_vCode}}</p>
        <div class="item-vcode">
          <input
            type="text"
            v-model.trim="formInfo.vcode"
            @blur="verificationVcode"
            :placeholder="info.holder_vCode"
          />
          <img :src="vcodeUrl?vcodeUrl:''" alt @click="getVcode"/>
          <span @click="getVcode">{{info.change_vCode}}</span>
        </div>
        <div class="item-tips">
          <div v-if="tipsInfo.vcode.isError">{{tipsInfo.vcode.msg}}</div>
        </div>
      </div>
      <div class="certificate-operate">
         <button :class="['search',success?'pendding':'']" @click="search" :disabled="success">{{info.search}}</button>
      </div>
    </div>
    <div class="listbox">

    <table class="table" style="border-bottom: 0px;">
      <thead>
        <tr>
          <td style="width:3.7%">{{info.tableHeader_1}}</td>
          <td style="width:40.2%; text-align: left; padding-left: 10px;">{{info.tableHeader_2}}</td>
          <td style="width:46%; text-align: left; padding-left: 10px;">{{info.tableHeader_3}}</td>
        </tr>
      </thead>
    </table>
     <div class="searchlist" v-if="serachList.length" :style="{'width': '1091px','height':'239px','overflow-y':serachList.length>=8?'scroll':'visible','margin-left': '0px'}">
        <table class="table">
            <tbody v-if="serachList.length">
            <tr v-for="(item,index) in serachList" :key="index">
              <td style="width:4.17%">{{index+1}}</td>
              <td style=" text-align: left; padding-left: 10px;position: relative;">
                <input
                  id="input"
                  ref="text"
                  :value="copymag"
                  style="opacity:0;  position: absolute;left:0;"
                />
                <span class="ID-txt">{{item.txid?item.txid:"未查询到相关数据"}}</span>
                <i class="copyTxid" v-if="item.txid!=='未查询到相关数据' && item.txid!==''" :data-clipboard-text="item.txid" @click="EvidenceCopyTxid(index)"></i>
                 <span class="copybox none">复制成功</span>
              </td>
              <td style="width:549.5px; text-align: left; padding-left: 10px; position: relative;">
                <input
                  id="input"
                  ref="text1"
                  :value="copymag1"
                  style="opacity:0;  position: absolute;left:0"
                />
                <span class="ID-txt">{{item.gzcourt_cert_id?item.gzcourt_cert_id:"未查询到相关数据"}}</span>
                <i class="copyHash" v-if="item.gzcourt_cert_id!=='未查询到相关数据' && item.gzcourt_cert_id!==''"  :data-clipboard-text="item.gzcourt_cert_id" @click="EvidenceCopyHash(index)"></i>
                <span class="copybox1 none">复制成功</span>
              </td>
            </tr>
          </tbody>
       <tbody v-if="!serachList.length">
         <tr >
          <td style="width:3.7%"></td>
          <td style=" text-align: left; padding-left: 10px;position: relative;"> 
            <span class="ID-txt" v-if="!noList"></span>
             <span class="ID-txt" v-else>{{info.errCode}}</span>
              <!-- <i class="copyHash" v-if="item.gzcourt_cert_id!=='未查询到相关数据'"  :data-clipboard-text="item.gzcourt_cert_id" @click="EvidenceCopyHash()"></i>
              <span class="copybox none" >复制成功</span> -->
          </td>
          <td style="width:510px; text-align: left; padding-left: 10px; position: relative;">
            <span class="ID-txt" v-if="!noList"></span>
               <span class="ID-txt" v-else>{{info.errCode}}</span>
                <!-- <i class="copyHash" v-if="item.gzcourt_cert_id!=='未查询到相关数据'"  :data-clipboard-text="item.gzcourt_cert_id" @click="EvidenceCopyHash()"></i>
                 <span class="copybox1 none">复制成功</span> -->
          </td>
        </tr>
      </tbody>
        </table>
    </div>
      <div class="searchlist" v-if="!serachList.length" :style="{'width': '1091px','height':'239px','overflow-y':serachList.length>=8?'scroll':'visible','margin-left':'0px'}">
        <table class="table">
            <tbody v-show="!serachList.length">
              <tr >
                <td style="width: 4.13%;"></td>
                <td style=" text-align: left; padding-left: 10px;position: relative;"> 
                  <span class="ID-txt" v-if="!noList"></span>
                    <span class="ID-txt" v-else>{{info.errCode}}</span>
                 
                </td>
                <td style="width:549.5px; text-align: left; padding-left: 10px; position: relative;">
                  <span class="ID-txt" v-if="!noList"></span>
                    <span class="ID-txt" v-else>{{info.errCode}}</span>
                </td>
              </tr>
            </tbody>
        </table>
    </div>
    </div>
    </template>
    <template v-if="isShowInfos">
       <div class="hzlist" >
          <p><img src="../../assets/images/validateQuery/tixing_icon.png" style="display:inline-block"/></p>
          <p class="hzlist_desc">{{info.desc_text}}</p>
          <div class="hzlist_desc_bz"> <img :src="require(`../../assets/images/validateQuery/${$route.path.indexOf('en')==1?'pic_hhyw':'pic_hhzw'}_img.png`)" alt=""/></div>
          <button type="button" class="hzlist_back" @click="goBackHz">{{info.buttonText}}</button>
        </div>
    </template>
  </div>
</template>
<script>
import { vaildateIDCard, ivaildateBLCard } from "@/utils/validate";
import Clipboard from 'clipboard'; 
import $ from "jquery";
export default {
  data() {
    return {
       copymag:this.info.errCode,
      copymag1:this.info.errCode, 
      successCopy:false,
      idCopy:false,
      success:false,
      noList:false,
      formInfo: {
        number: "",
        code: "",
        vcode: ""
      },
      submitInfo: {
        number: "",
        code: "",
        vcode: ""
      },
      tipsInfo: {
        number: {
          isError: false,
          msg: this.info.err
        },
        vcode: {
          isError: false,
          msg: this.info.err
        }
      },
      vcodeUrl:"",
      serachList:[],
      isShowInfos:false
    };
  },
  props: ['info'],
  computed: {},
  methods: {
    // 验证证书编号
  verificationNumber() {
      let number=/^(([A-Z]+\-[A-Z]+\-)|([A-Z]+\-))(\d{16}|\d{18}|\d{20})$/;
      let code=/^[A-Z]{2}[a-f0-9]{8}\d{13}$/;
      this.submitInfo.number="";
      if (this.formInfo.number.trim()) {
         this.formInfo.number=this.formInfo.number.trim();
        if (number.test(this.formInfo.number)) {
          this.submitInfo.number=this.formInfo.number;
          this.tipsInfo.number.isError = false;
          return true;
        } else if(code.test(this.formInfo.number)||this.formInfo.number.length==20){
          this.submitInfo.code=this.formInfo.number;
          this.tipsInfo.number.isError = false;
          return true;
        }else{
          this.tipsInfo.number.isError = true;
          this.tipsInfo.number.msg = this.info.err;
          return false;
        }
      } else {
        this.tipsInfo.number.isError = true;
        this.tipsInfo.number.msg = this.info.void_1;
        return false;
      }
    },
    // 验证验证码
    verificationVcode() {
        this.submitInfo.vcode=""
      if (this.formInfo.vcode) {
        if (/^([a-z]|[A-Z]|[0-9]){4}$/.test(this.formInfo.vcode)) {
          this.tipsInfo.vcode.isError = false;
            this.submitInfo.vcode=this.formInfo.vcode;
          return true;
        } else {
          this.tipsInfo.vcode.isError = true;
          this.tipsInfo.vcode.msg = this.info.err;
          return false;
        }
      } else {
        this.tipsInfo.vcode.isError = true;
        this.tipsInfo.vcode.msg = this.info.void_vCode;
        return false;
      }
    },
    //查询
    search() {
      if(this.verificationNumber()&&this.verificationVcode()){
        this.isShowInfos=true;
      }else{
        this.verificationNumber();
        this.verificationVcode();
      }
      
    },
    clearAll(){
       this.submitInfo.number="";
        this.submitInfo.vcode=""
         this.submitInfo.code=""
          this.formInfo.number = "";
      this.formInfo.code = "";
      this.formInfo.vcode = "";
    },
    //继续查询
    continueSearch() {
      this.formInfo.number = "";
      this.formInfo.code = "";
      this.formInfo.vcode = "";

      this.tipsInfo.number.isError = false;
      this.tipsInfo.code.isError = false;
      this.tipsInfo.vcode.isError = false;
      this.isSearch = true;
    },
        //更换验证码
    getVcode () {
       this.$ajax.get("/webapi/common/getCode").then(res=>{
          if(res.data.code==200){
            this.vcodeUrl="data:image/png;base64,"+res.data.extraData.code
          }
       })
    },
    goBackHz(){
      this.isShowInfos=false;
      this.clearAll()
    },
     //复制id
    EvidenceCopyTxid(ind) {
       var clipboard = new Clipboard(".copyTxid");
      //  console.log(ind,   $('.copybox').eq(ind))
        clipboard.on("success", e => {
       $('.copybox').eq(ind).removeClass('none').addClass("block");
        setTimeout(() => {
                 $('.copybox').eq(ind).removeClass('block').addClass("none");
        }, 1000);
  //         this.$message({type:"success",message:"复制成功",}); //这里你如果引入了elementui的提示就可以用，没有就注释即可
          // 释放内存
          clipboard.destroy();
        });
    },
    EvidenceCopyHash(ind){
        var clipboard = new Clipboard(".copyHash");
        clipboard.on("success", e => {
           $('.copybox1').eq(ind).removeClass('none').addClass("block");
        setTimeout(() => {
                 $('.copybox1').eq(ind).removeClass('block').addClass("none");
        }, 1000);
  //         this.$message({type:"success",message:"复制成功"}) //这里你如果引入了elementui的提示就可以用，没有就注释即可
          // 释放内存
          clipboard.destroy();
        });
    }
  },
  mounted(){
    this.getVcode();
  }
  ,watch:{
			'$route' () {
				let pos = this.$router.history.current.path.indexOf("cn");
				if (pos) {
           if (this.formInfo.vcode.trim()) {
             this.tipsInfo.vcode.msg = this.info.err;
           }else{
             this.tipsInfo.vcode.msg = this.info.void_vCode;
           }
           if (this.formInfo.number.trim()) {
              this.tipsInfo.number.msg = this.info.err;
           }else{
               this.tipsInfo.number.msg = this.info.void_1;
           }
          
				}
			}
		}
};
</script>
<style lang="scss" scoped>
.hzlist{
  width: 1200px;
  margin: 0 auto;
  margin-top: 45px;
  z-index: 99;
  position: relative;
  p{
    width: 100%;
    text-align: center;
   
  }
  .hzlist_desc{
     font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #60A1E3;
     width: 778px;
    margin:0 auto;
    margin-top:10px;
  }
  .hzlist_desc_bz{
    width: 778px;
    height: 240px;
    margin:0 auto;
    margin-top:30px;
    img{
      width: 100%;
    }
  }
  .hzlist_back{
    width: 284px;
    height: 46px;
    background: #AB2735;
    border: 1px solid #AB2735;
    display: block;
    margin: 20px auto;
    color: #ffffff;
    font-size: 16px;
  }
  .hzlist_back:hover{
    background:#ea4b5d
  }
}
.region {
  width: 100%;
  .certificate {
    display: flex;
    justify-content: space-between;
    width: 1074px;
    padding-top: 40px;
    margin: 0 auto;
    &-item {
      margin-bottom: 6px;
      margin-top: -10px;
      .item {
        &-title {
          height: 16px;
          line-height: 16px;
          font-size: 14px;
          color: #fff;
        }
        &-input {
          input {
            outline: none;
            width: 452px;
            height: 40px;
            padding-left: 14px;
            border: 1px solid #f1f1f1;
            margin-top: 10px;
            font-size: 12px;
          }
        }
        &-tips {
          height: 28px;
          div {
            height: 28px;
            line-height: 28px;
            padding-left: 14px;
            font-size: 12px;
            color: #d0444f;
          }
        }
        &-vcode {
          input {
            outline: none;
            width: 198px;
            height: 40px;
            padding-left: 14px;
            border: 1px solid #f1f1f1;
            margin-top: 10px;
            font-size: 12px;
          }
          img {
            width: 90px;
            height: 40px;
            margin-left: 15px;
            vertical-align: middle;
          }
          span {
            display: inline-block;
            height: 40px;
            line-height: 40px;
            margin-left: 15px;
            color: #bfbfc2;
            cursor: pointer;
            font-size: 14px;
          }
        }
      }
    }
    &-operate {
      display: flex;
      justify-content: space-between;
      width: 177px;
      height: 95px;
      padding-top: 16px;
      button {
        width: 100%;
        height: 40px;
        line-height: 40px;
        background-color: #c62e3f;
        color: #fff;
        font-size: 14px;
        &:hover {
          background-color: #ea4b5d;
        }
      }
      .pendding{
        background: #d2d2d2;
        color: #fff;
      }
     
      .pendding:hover{
        background: #d2d2d2 !important;
        color: #fff;
      }
    }
  }
  .table {
    width: 1074px;
    // margin: 0 auto;
    color: #fff;
    border-right: 1px solid #d2d2d2;
    border-bottom: 1px solid #d2d2d2;
    border-collapse: collapse;
    border-spacing: 0;
    tr {
      td {
        position: relative;
        height: 34px;
        text-align: center;
        vertical-align: middle;
        word-break: break-all;
        font-size: 12px;
        border-top: 1px solid #d2d2d2;
        border-left: 1px solid #d2d2d2;
        cursor: pointer;
        i {
          position: absolute;
          top: 50%;
          right: 8px;
          transform: translateY(-50%);
          width: 14px;
          height: 16px;
          vertical-align: middle;
          background: url('~img/validateQuery/rescue_nor_icon.png') center no-repeat;
        }
        .copybox{
          width: 60px;
          height:20px;
          background: #fff;
          text-align: center;
          line-height: 20px;
          color:#002662;
          font-size: 12px;
          border-radius: 2px;
          display: inline-block;
          position: absolute;
          right: 27px;
          z-index: 9;
          top: 5px;
        }
         .copybox1{
          width: 60px;
          height:20px;
          background: #fff;
          text-align: center;
          line-height: 20px;
          color:#002662;
          font-size: 12px;
          border-radius: 2px;
          display: inline-block;
          position: absolute;
          right: 27px;
          z-index: 9;
          top: 5px;
        }
        .none{
          display: none;
        }
        .block{
          display: block;
        }
      }
     
      // & + tr {
      //   td + td {
      //     &:hover {
      //       color: #ea4b5d;
      //       i {
      //         background: url('~img/validateQuery/rescue_hov_pre_icon.png') center no-repeat;
      //       }
      //     }
      //   }
      // }
    }
  }
  tbody  td:hover{
        color: #ea4b5d;
      }
      tbody  td:hover i{
           background: url('~img/validateQuery/rescue_hov_pre_icon.png') center no-repeat;
      }
  .ID-txt {
    text-overflow: ellipsis;
    display: inline-block;
    width: 419px;
    box-sizing: border-box;
    padding-right: 20px;
    white-space: nowrap;
    overflow: hidden;
  }
}
.listbox{
  width: 1092px;
    margin: 0 auto;
    padding-left: 9px;
}
</style>
